// Exports
export default {
	"stub": "stub_GqSai",
	"stubInner": "stubInner_xXm+s",
	"stubImage": "stubImage_7fuKu",
	"stubTitle": "stubTitle_PNRaQ",
	"stubText": "stubText_fLrP2"
};
